import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  NotifyRequestOwnerDto,
  SendManualNotificationDto,
  SendNewAppointmentNotificationDto
} from './notifications.dto';
import { Notification } from './notifications.type';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  apiUrl = `${environment.apiBase}`;

  constructor(private http: HttpClient) {}

  send(input: SendManualNotificationDto) {
    return this.http.post(`${this.apiUrl}/board/notifications/send/`, input);
  }

  sendNewAppointmentNotification(input: SendNewAppointmentNotificationDto) {
    return this.http.post(`${this.apiUrl}/board/notifications/send/newAppointment/`, input);
  }

  sendNotificationToRequestOwner(input: NotifyRequestOwnerDto) {
    return this.http.post(`${this.apiUrl}/board/notifications/notifyOwner/`, input);
  }

  getEmployeeNotifications(page = 1, limit = 10) {
    return this.http.get(`${this.apiUrl}/board/notifications`, {
      params: { page: String(page), limit: String(limit) }
    });
  }

  toggleNotificationReadStatus(notificationId: number) {
    return this.http.post<{ data?: { unreadCount: number }; statusCode: number }>(
      `${this.apiUrl}/board/notifications/${notificationId}/toggle-read`,
      {}
    );
  }

  markAllRead() {
    return this.http.post<{ data?: { unreadCount: number }; statusCode: number }>(
      `${this.apiUrl}/board/notifications/read-all`,
      {}
    );
  }
}
